<article class="disease-profile">
  <header class="disease-profile__header">
    @if (profile$(); as profile) {
      <app-header
        [title]="profile.name"
        [subTitle]="profile?.category?.name"
        [text]="profile.summary | stripHtml"
        [imgUrl]="profile.image?.absoluteUrl"
        [graphic]="profile.headerGraphic"
      >
        @if (pages$().length) {
          <button class="button button--primary mt-2" (click)="scrollToInfo()">
            <span>{{ 'disease-header-button-tekst' | fromDictionary }}</span>
          </button>
        }
      </app-header>
    }
  </header>

  @if (profile$(); as profile) {
    @if (pages$().length || profile.informationPages.length) {
      <section class="section-inset-y" id="DiseaseInfo" #diseaseInfoEl>
        <div class="container disease-info">
          <div class="disease-info__figure">
            <figure
              class="blob-image"
              [ngStyle]="{
                'background-image':
                  'url(' + ('ziektebeeld-informatie-afbeelding' | fromDictionary | resize: 700 : 700 : 'middlecenter') + ')',
              }"
            ></figure>
          </div>
          <div class="disease-info__content">
            <div class="title-max-width">
              <h1 class="h2">{{ 'informatie-titel' | fromDictionary }}</h1>
              <ul class="d-flex flex-wrap mt-6">
                @for (page of profile.informationPages; track page.id) {
                  <li class="mb-2 mr-2">
                    <a class="button button--primary" [routerLink]="['informatie', page.slug]">
                      <span>{{ page.slug }}</span>
                    </a>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      </section>
    }
    @if (profile.infographic) {
      <app-infographic-slider
        [diseaseProfileTitle]="profile.name"
        [images]="profile.infographic"
        [knowledgeCardsUrl]="profile.knowledgeCardsUrl || undefined"
      ></app-infographic-slider>
    }
    @if (profile.communities.length) {
      <section class="section-inset-y disease-profile__group">
        <div class="container">
          <div class="text-center">
            <h2>
              <small class="text-primary">{{ 'groepen-subtitel' | fromDictionary }}</small>
              {{ 'groepen-titel' | fromDictionary }}
            </h2>
            <p class="title-max-width mx-auto">{{ 'groepen-intro-tekst' | fromDictionary }}</p>
          </div>
          <ul class="row mt-6" [class.justify-content-center]="profile.communities.length === 1">
            @for (item of profile.communities; track item.id) {
              <li class="col-12 col-sm-6 d-flex mt-4 mb-6" [class.col-sm-8]="profile.communities.length === 1">
                <div>
                  <span class="icon-round mr-4" [ngClass]="groupClass(item, true)">
                    <fstr-icon class="icon-sm icon-white" [anchor]="'icon-' + item.icon"></fstr-icon>
                  </span>
                </div>
                <div class="pr-sm-4">
                  <h1 class="h5">{{ item.title }}</h1>
                  <p>{{ item.description }}</p>
                  @if (item.url) {
                    <a [href]="item.url" target="_blank" class="button button--sm" [ngClass]="groupClass(item, false)">
                      <span>{{ 'groepen-knop-tekst' | fromDictionary }}</span>
                    </a>
                  }
                </div>
              </li>
            }
          </ul>
        </div>
      </section>
    }
    @if (pages$(); as extraInfoPages) {
      @if (extraInfoPages.length) {
        <section class="section-inset-y">
          <div class="container">
            <div class="text-center">
              <h2>
                @if (!('extra-info-subtitel' | fromDictionary).startsWith('TEXT')) {
                  <small class="text-primary">
                    {{ 'extra-info-subtitel' | fromDictionary }}
                  </small>
                }
                {{ 'extra-info-titel' | fromDictionary }}
              </h2>
              @if (!('extra-info-intro-tekst' | fromDictionary).startsWith('TEXT')) {
                <p class="title-max-width mx-auto">{{ 'extra-info-intro-tekst' | fromDictionary }}</p>
              }
            </div>
            <ul class="row mb-8 justify-content-center">
              @for (infoPage of extraInfoPages; track infoPage.id) {
                <li class="col-sm-6 mb-2 mb-lg-0 col-lg-4 d-flex justify-content-center">
                  @if (infoPage.externalUrl) {
                    <app-href-card
                      [target]="'_blank'"
                      [href]="infoPage.externalUrl"
                      [title]="infoPage?.menuTitle || infoPage?.title"
                      [imageUrl]="infoPage?.imageUrl"
                      [imageAnchor]="infoPage?.imageAnchor"
                    ></app-href-card>
                  }
                  @if (!infoPage.externalUrl) {
                    <app-card
                      [title]="infoPage?.menuTitle || infoPage?.title"
                      [link]="['./', infoPage.id.toString(), infoPage?.menuTitle || infoPage?.title | urlRewrite]"
                      [imageUrl]="infoPage?.imageUrl"
                      [imageAnchor]="infoPage?.imageAnchor"
                    ></app-card>
                  }
                </li>
              }
            </ul>
          </div>
        </section>
      }
    }
    @if (profile.news.length) {
      <section class="section-inset-y bg-blob bg-blob--news">
        <div class="container">
          @if (profile.events.length) {
            <div class="section__header">
              <h2 class="mb-0">Agenda</h2>
              <a class="button button-link button-link--muted mb-0" [routerLink]="['/evenementen']">
                <span>Alle evenementen</span>
              </a>
            </div>
            <ul class="row mb-8">
              @for (item of profile.events; track item.id) {
                <li class="col-sm-6 mb-2 mb-lg-0 col-lg-4 d-flex">
                  <app-card
                    [title]="item.title"
                    [date]="item.publishDate"
                    [link]="item.routerLink"
                    [imageUrl]="item.imageUrl"
                    [imageAnchor]="item?.imageAnchor"
                    [showTime]="true"
                    [showDate]="true"
                  ></app-card>
                </li>
              }
            </ul>
          }
          @if (profile.news.length) {
            <div class="section__header">
              <h2 class="mb-0">Nieuws</h2>
              <a class="button button-link button-link--muted mb-0" [routerLink]="['/nieuws']">
                <span>Al het nieuws</span>
              </a>
            </div>
            <ul class="row">
              @for (item of profile.news; track item.id) {
                <li class="col-sm-6 mb-2 mb-lg-0 col-lg-4 d-flex">
                  <app-card
                    [title]="item.title"
                    [date]="item.publishDate"
                    [text]="item.text | stripHtml | truncate: 150"
                    [imageUrl]="item.imageUrl"
                    [imageAnchor]="item?.imageAnchor"
                    [link]="item.routerLink"
                    [showDate]="true"
                  ></app-card>
                </li>
              }
            </ul>
          }
        </div>
      </section>
    }
    @if (profile.highlightedArticle.title) {
      <section class="section-inset-y">
        <div>
          <app-highlighted-article [article]="profile.highlightedArticle"></app-highlighted-article>
        </div>
      </section>
    }
    @if (profile.carePathPatients || profile.carePathPractitioners) {
      <section class="section-inset-y">
        <div class="container">
          <div class="text-center">
            <h2>
              @if (!('zorgpaden-subtitel' | fromDictionary).startsWith('TEXT')) {
                <small class="text-primary">
                  {{ 'zorgpaden-subtitel' | fromDictionary }}
                </small>
              }
              {{ 'zorgpaden-titel' | fromDictionary }}
            </h2>
            <p class="title-max-width mx-auto">{{ 'zorgpaden-intro-tekst' | fromDictionary }}</p>
          </div>
          <ul class="row care-paths mt-6 justify-content-center">
            @if (profile.carePathPatients) {
              <li class="col-md-6 mb-2 mb-lg-0">
                <app-href-card
                  [size]="'xs'"
                  [target]="'_blank'"
                  [href]="profile.carePathPatients"
                  [title]="'Voor patiënten'"
                ></app-href-card>
              </li>
            }
            @if (profile.carePathPractitioners) {
              <li class="col-md-6 mb-2 mb-lg-0">
                <app-href-card
                  [size]="'xs'"
                  [target]="'_blank'"
                  [href]="profile.carePathPractitioners"
                  [title]="'Voor behandelaren'"
                ></app-href-card>
              </li>
            }
          </ul>
        </div>
      </section>
    }
  }

  @if (blogs$().length) {
    <app-blog-block [blogs]="blogs$()"></app-blog-block>
  }

  <section class="section-inset-y">
    <div class="container text-center">
      <a [routerLink]="['/', 'stofwisselingsziekten']" class="button button--primary">
        <fstr-icon anchor="icon-arrow-left"></fstr-icon>
        <span>Terug naar stofwisselingsziekten overzicht</span>
      </a>
    </div>
  </section>

  <!-- <app-theme-switcher></app-theme-switcher> -->

  <!-- <pre>{{ profile$() | json }}</pre> -->
</article>
